import { DiscountType } from 'typings'

export const allowedDiscountTypes = [DiscountType.Price]
